import { lazy } from "react";
import Dashboard from "../../../Pages/Dashboard/Dashboard";
import MembershipTaskList from "../../../Pages/MembershipTaskList/MembershipTaskList";
import ViewIndividualMember from "../../../Pages/ViewIndividualMember/ViewIndividualMember";
import EditMembershipTaskList from "../../../Pages/MembershipTaskList/EditMembershipTaskList";
import PaymentReconciliationRecord from "../../../Pages/PaymentReconciliationRecord/PaymentReconciliationRecord";
import EditViewIndividualMember from "../../../Pages/ViewIndividualMember/EditViewIndividualMember";
import MembershipPricing from "../../../Pages/MembershipPricing/MembershipPricingTable";
import EmailTemplateManage from "../../../features/FiledManagement/EmailTemplateManagement/EmailTemplateManage";
import EditEmailTemplate from "../../../Pages/FieldManagement/EmailTemplateManagement/EditEmailTemplate";
import AddEmailTemplate from "../../../Pages/FieldManagement/EmailTemplateManagement/AddEmailTemplate";
import DropdownManagementFeature from "../../../features/FiledManagement/DropdownManagement/DropdownManagement";
import AdmissionCommitteeList from "../../../Pages/AdmissionCommitteeManagement/AdmissionCommittee";
import BoardCommitteeList from "../../../Pages/BoardCommitteeManagement/BoardCommittee";
import ViewEditEventManagement from "../../../Pages/EventManagement/ViewEditEventManagement";
import EventManagement from "../../../Pages/EventManagement/EventManagement";
import EventFeedbackQuestion from "../../../Pages/EventManagement/EventFeedbackQuestion";
import EventQuestionAnswer from "../../../Pages/EventManagement/EventQuestionAnswer";
import EventGallery from "../../../Pages/EventsGallery/EventsGallery";
import ManageEventGallery from "../../../Pages/EventsGallery/ManageEventGallery";
import EditEventGallery from "../../../Pages/EventsGallery/EditEventGallery";
import ViewResources from "../../../Pages/Resources/ViewResources";
import CreateResources from "../../../Pages/Resources/CreateResources";
import PostReview from "../../../Pages/Resources/PostReview";
import WorkgroupMapping from "../../../Pages/Membership/CommitteeWorkgroupMapping"
import CreateHonoryMember from "../../../Pages/HonoraryMembership/CreateHonoryMember";
import ReinstatementMembershipTaskList from "../../../Pages/MembershipTaskList/ReinstatementMembershipTaskList";
import GenerateManualEventAttendenceCertificate from "../../../Pages/GenerateManualEventAttendenceCertificate/GenerateManualEventAttendenceCertificate";
import NotificationBarManagement from "../../../Pages/NotificationBarManagement";
import BookingCancelation from "../../../Pages/BookingCancelation/BookingCancelation";
import BookingCancelationDetails from "../../../Pages/BookingCancelation/BookingCancelationDetails";
import UpgradeMembershipTaskList from "../../../Pages/MembershipTaskList/UpgradeMembershipTaskList";
import EditUpgradeMembershipTaskList from "../../../Pages/MembershipTaskList/EditUpgradeMembershipTaskList";
import EditViewUpgradeMember from "../../../Pages/ViewIndividualMember/EditViewUpgradeMember";

//IPAS Admin Pages

export const ComponentNavigation = [
  {
    id: "MembershipTaskList",
    path: "/MembershipTaskList",
    exact: true,
    title: "Membership Task List",
    component: MembershipTaskList,
    text: "MembershipTaskList",
  },
  {
    id: "UpgradeMembershipTaskList",
    path: "/UpgradeMembershipTaskList",
    exact: true,
    title: "Upgrade Membership Task List",
    component: UpgradeMembershipTaskList,
    text: "UpgradeMembershipTaskList",
  },
  {
    id: "ReinstatementMembershipTaskList",
    path: "/ReinstatementMembershipTaskList",
    exact: true,
    title: "Reinstatement Membership Task List",
    component: ReinstatementMembershipTaskList,
    text: "MembershipTaskList",
  },
  {
    id: "editMembershipTaskList",
    path: "/EditMembershipTaskList/:memberId/:taskListId",
    exact: true,
    title: "Edit Membership Task List",
    component: EditMembershipTaskList,
    text: "Edit Membership Task List",
  },
  {
    id: "editUpgradeMembershipTaskList",
    path: "/EditUpgradeMembershipTaskList/:memberId/:taskListId",
    exact: true,
    title: "Edit Upgrade Membership Task List",
    component: EditUpgradeMembershipTaskList,
    text: "Edit Upgrade Membership Task List",
  },
  {
    id: "ViewIndividualMember",
    path: "/ViewIndividualMember",
    exact: true,
    title: "View Individual Member",
    component: ViewIndividualMember,
    text: "ViewIndividualMember",
  },
  {
    id: "editViewIndividualMember",
    path: "/editViewIndividualMember/:memberId",
    exact: true,
    title: "Edit View Individual Member",
    component: EditViewIndividualMember,
    text: "Edit Individual Member",
  },
  {
    id: "editViewUpgradeMember",
    path: "/editViewUpgradeMember/:memberId",
    exact: true,
    title: "Edit View Upgrade Member",
    component: EditViewUpgradeMember,
    text: "Edit Upgrade Member",
  },
  {
    id: "paymentReconciliation",
    path: "/PaymentReconciliation",
    exact: true,
    title: "Payment Reconciliation",
    component: PaymentReconciliationRecord,
    text: "Payment Reconciliation",
  },
  {
    id: "dashboard",
    path: "/",
    exact: true,
    title: "Dashboard",
    component: Dashboard,
    hasParams: false,
    text: "Dashboard",
    securityKey: "",
  },
  {
    id: "membershipPricing",
    path: "/membershipPricing",
    exact: true,
    title: "Membership Pricing",
    component: MembershipPricing,
    hasParams: false,
    text: "Membership Pricing",
    securityKey: "",
  },
  //Field Maintanance
  {
    id: "emailTemplateManagement",
    path: "/emailTemplateManagement",
    exact: true,
    title: "Email Template Management",
    component: EmailTemplateManage,
    hasParams: false,
    text: "Email Template Management",
    securityKey: "",
  },
  {
    id: "editEmailTemplateManagement",
    path: "/emailTemplateManagement/:id",
    exact: true,
    title: "Email Template Management",
    component: EditEmailTemplate,
    hasParams: false,
    text: "Edit Email Template Management",
    securityKey: "",
  },
  {
    id: "addEmailTemplate",
    path: "/emailTemplateManagement/addEmailTemplate",
    exact: true,
    title: "Add Email Template",
    component: AddEmailTemplate,
    hasParams: false,
    text: "Add Email Template",
    securityKey: "",
  },
  {
    id: "dropdownManagement",
    path: "/dropdownManagement",
    exact: true,
    title: "Dropdown Management",
    component: DropdownManagementFeature,
    hasParams: false,
    text: "Dropdown Management",
    securityKey: "",
  },

  //Field Maintanance end

  //Admission Committee Management
  {
    id: "AdmissionCommitteeList",
    path: "/AdmissionCommitteeList",
    exact: true,
    title: "Admission Committee List",
    component: AdmissionCommitteeList,
    text: "AdmissionCommitteeList",
  },

  //Board Committee Management
  {
    id: "BoardCommitteeList",
    path: "/BoardCommitteeList",
    exact: true,
    title: "Board of Directors List",
    component: BoardCommitteeList,
    text: "BoardCommitteeList",
  },
  //Event Management
  {
    id: "viewEditEvent",
    path: "/viewEditEvent",
    exact: true,
    title: "View / Edit Event",
    component: ViewEditEventManagement,
    hasParams: false,
    text: "View Edit Event",
    securityKey: "",
  },

  //Event Managment
  {
    id: "CreateEvents",
    path: "/CreateEvents",
    exact: true,
    title: "Create Events",
    component: EventManagement,
    text: "CreateEvents",
  },

  //Event Managment
  {
    id: "EventFeedbackQuestion",
    path: "/eventFeedbackQuestion",
    exact: true,
    title: "Event Feedback Question",
    component: EventFeedbackQuestion,
    text: "EventFeedbackQuestion",
  },
  //Event Managment
  {
    id: "EventQuestionAnswer",
    path: "/eventQuestionAnswer",
    exact: true,
    title: "Event Question Answer",
    component: EventQuestionAnswer,
    text: "EventQuestionAnswer",
  },
  {
    id: "generateManualEventAttendenceCertificate",
    path: "/GenerateManualEventAttendenceCertificate",
    exact: true,
    title: "Manual Feedback/Cert Generation",
    component: GenerateManualEventAttendenceCertificate,
    text: "GenerateManualEventAttendenceCertificate",
  },
  //Event Gallery
  {
    id: "eventsGalleryList",
    path: "/eventsGalleryList",
    exact: true,
    title: "Events Gallery Listing",
    component: EventGallery,
    text: "eventsGalleryList",
  },
  {
    id: "manageEventGallery",
    path: "/manageEventGallery",
    exact: true,
    title: "Manage Event Gallery",
    component: ManageEventGallery,
    text: "manageEventGallery",
  },
  {
    id: 'editmanageEventGallery',
    path: '/editmanageEventGallery/:id',
    exact: true,
    title: 'Edit Manage Event Gallery',
    component: EditEventGallery,
    hasParams: false,
    text: 'Manage Event Gallery',
    securityKey: ""
  },

  //Resources

  {
    id: "viewResources",
    path: "/viewResources",
    exact: true,
    title: "View Resources",
    component: ViewResources,
    text: "viewResources",
  },
  {
    id: "createResources",
    path: "/createResources",
    exact: true,
    title: "Create Resources",
    component: CreateResources,
    text: "createResources",
  },
  {
    id: "postReview",
    path: "/postReview",
    exact: true,
    title: "",
    component: PostReview,
    text: "PostReview",
  },

  //Membership
  {
    id: "workgroupMapping",
    path: "/workgroupMapping",
    exact: true,
    title: "Leadership Management",
    component: WorkgroupMapping,
    text: "Workgroup Mapping",
  },

  //Honorary Membership
  {
    id: "HonoraryMember",
    path: "/HonoraryMember",
    exact: true,
    title: "Create Honorary Member",
    component: CreateHonoryMember,
    text: "HonoraryMember",
  },
  {
    id: "NotificationBarManagement",
    path: "/NotificationBarManagement",
    exact: true,
    title: "Notification Bar Management",
    component: NotificationBarManagement,
    text: "MembershipTaskList",
  },
  {
    id: "BookingCancellation",
    path: "/BookingCancellation",
    exact: true,
    title: "Booking Cancellation",
    component: BookingCancelation,
    text: "BookingCancellation",
  },
  {
    id: 'BookingCancellationDetails',
    path: '/BookingCancellationDetails/:id',
    exact: true,
    title: 'Booking Cancellations Details',
    component: BookingCancelationDetails,
    text: 'Booking Cancellation Details',
  },
];
